import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't scroll here - let the router handle it with the loader
    // This prevents double scrolling
  }, [pathname]);

  return null;
};

export default ScrollToTop;

